<template>
  <v-dialog v-model="openMode" max-width="500px" content-class="contact-dialog">
    <v-card class="contact-card">
      <div class="dialog-header">
        <h2 class="dialog-title">{{ formTitle }}</h2>
        <p class="dialog-subtitle">{{ formTitle === 'ערוך איש קשר' ? 'עדכן את פרטי איש הקשר' : 'הוסף איש קשר חדש למערכת'
        }}</p>
      </div>

      <v-divider class="mx-4"></v-divider>

      <v-card-text class="pt-5">
        <v-form @submit.prevent="submitHandler" ref="form">
          <div class="form-fields">
            <!-- Name Field -->
            <div class="form-field">
              <v-text-field v-model="itemEdited.name" outlined dense label="שם" prepend-inner-icon="mdi-account"
                placeholder="הכנס שם מלא" hide-details="auto" class="field-input"></v-text-field>
            </div>

            <!-- Phone Field -->
            <div class="form-field">
              <v-text-field v-model="itemEdited.phone" outlined dense label="טלפון" prepend-inner-icon="mdi-phone"
                maxlength="13" type="number" hide-spin-buttons :rules="[v => !!v || 'שדה חובה']" required
                placeholder="הכנס מספר טלפון" hide-details="auto" class="field-input"></v-text-field>
            </div>

            <!-- Country Code Field -->
            <div class="form-field">
              <v-autocomplete :items="coutryCodes" v-model="itemEdited.callerid_country_code" item-text="he"
                item-value="en" outlined dense label="זיהוי מדינה לקבלת צינתוק" prepend-inner-icon="mdi-flag"
                :rules="[v => !!v || 'שדה חובה']" required hide-details="auto" class="field-input"></v-autocomplete>
            </div>

            <!-- Role Field -->
            <div class="form-field">
              <v-select :items="roles" v-model="itemEdited.role" outlined dense label="הרשאות"
                prepend-inner-icon="mdi-shield-account" :rules="[v => !!v || 'שדה חובה']" required hide-details="auto"
                class="field-input"></v-select>
            </div>

            <!-- save_last_listen_policy Field -->
            <div class="form-field">
              <v-select v-model="itemEdited.save_last_listen_policy" :items="saveLastListenPolicyOptions"
                label="שמירת מיקום אחרון שהאזינו" item-text="text" item-value="value" :rules="[v => !!v || 'שדה חובה']"  dense outlined />
            </div>

            <!-- Send Call Option -->
            <div class="form-field checkbox-field">
              <v-checkbox v-model="sendCall" hide-details color="primary" class="send-call-checkbox">
                <template v-slot:label>
                  <span class="checkbox-label">שלח צינתוק</span>
                </template>
              </v-checkbox>
            </div>
          </div>
        </v-form>

        <!-- Loading Progress -->
        <v-slide-y-transition>
          <div class="progress-container" v-if="progressShow">
            <v-progress-circular indeterminate color="primary" size="32"></v-progress-circular>
            <div class="progress-text">{{ formTitle === 'ערוך איש קשר' ? 'מעדכן...' : 'מוסיף...' }}</div>
          </div>
        </v-slide-y-transition>
      </v-card-text>

      <v-card-actions class="dialog-actions">
        <v-btn text color="grey darken-1" @click="openMode = false" :disabled="progressShow" class="cancel-btn">
          ביטול
        </v-btn>

        <v-btn color="primary" :loading="progressShow" :disabled="progressShow"
          @click="formTitle === 'ערוך איש קשר' ? saveEditedSubscribe() : saveNewSubscribe()" class="action-btn">
          <v-icon left>{{ formTitle === 'ערוך איש קשר' ? 'mdi-content-save' : 'mdi-account-plus' }}</v-icon>
          {{ formTitle === 'ערוך איש קשר' ? "שמור שינויים" : "הוסף איש קשר" }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-snackbar v-model="snackbar" :timeout="4000">
      {{ snacbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn :color="snackbarColorBt" text v-bind="attrs" @click="snackbar = false">
          סגור
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import ApiServices from '@/services/api.service'
import sharedFunctions from '@/shared/sharedFunctions';

export default {
  props: {
    itemToEdit: Object,
    formTitle: String,
    value: { type: Boolean, default: false },
  },
  data: () => ({
    progressShow: false,
    snackbar: false,
    snackbarColorBt: "green",
    snacbarText: "",
    itemEdited: {
      name: "",
      phone: "",
      role: "user",
      callerid_country_code: "IL",
      save_last_listen_policy: "hangup_only",
    },
    sendCall: false,
    roles: ["user", "manager"],
    coutryCodes: [],
    saveLastListenPolicyOptions: [
      {
        text: "רק בניתוק שיחה",
        value: "hangup_only",
      },
      {
        text: "תמיד",
        value: "always",
      },
    ],
  }),
  methods: {
    async saveNewSubscribe() {
      if (this.$refs.form.validate()) {
        const datesJSON = JSON.stringify({ item: this.itemEdited, sendCall: this.sendCall });
        this.progressShow = true;
        let token = localStorage.getItem("token");

        try {
          let api = process.env.VUE_APP_BASE_URL + "/subscribes/create_subscribe";
          const res = await fetch(api, ApiServices.requestOptions("POST", datesJSON, token));
          this.progressShow = false;
          const jsonObject = await res.json();
          if (res.status >= 400) {
            this.$emit("subscribeCreated", "", " שגיאה בהוספת איש קשר: " + jsonObject, "red");
          } else if (res.status === 200) {
            this.itemEdited.by = "WEBSITE"
            this.$emit("subscribeCreated", jsonObject, "איש הקשר נוסף בהצלחה", "green");
            this.openMode = false;
          }
        } catch (error) {
          this.progressShow = false;
          this.showSnackBar("Error saved new contact: " + error, "red");
          this.$emit("subscribeCreated", "", "Error saved new contact: " + error, "red");
        }
      }
    },
    async saveEditedSubscribe() {
      if (this.$refs.form.validate()) {
        const datesJSON = JSON.stringify({ item: this.itemEdited });
        this.progressShow = true;
        let token = localStorage.getItem("token");

        try {
          let api = process.env.VUE_APP_BASE_URL + "/subscribes/update_subscribe";
          const res = await fetch(api, ApiServices.requestOptions("PUT", datesJSON, token));
          this.progressShow = false;
          const jsonObject = await res.json();
          if (res.status >= 400) {
            this.$emit("subscribeEdited", "", "error: " + jsonObject, "red");
          } else if (res.status === 200) {
            this.$emit("subscribeEdited", this.itemEdited, "איש הקשר עודכן בהצלחה", "green");
            this.openMode = false;
          }
        } catch (error) {
          this.progressShow = false;
          this.showSnackBar("Error saved list: " + error, "red");
          this.$emit("subscribeEdited", "", "Error edit date: " + error, "red");
        }
      }
    },
    async getCountryCodes() {
      this.coutryCodes = await sharedFunctions.getCountryCodes();
    },
    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color;
      this.snackbar = true
    },
  },
  computed: {
    openMode: {
      get() {
        return this.value
      },
      set(v) {
        return this.$emit('input', v)
      }
    },
  },
  mounted() {
    this.getCountryCodes();
    if (this.formTitle === "ערוך איש קשר") {
      this.itemEdited = { ...this.itemToEdit };
    }
  },
}
</script>

<style scoped>
.contact-dialog {
  border-radius: 16px;
}

.contact-card {
  border-radius: 16px;
  overflow: hidden;
  background: linear-gradient(to bottom, #ffffff, #f8f9fa);
}

.dialog-header {
  padding: 24px 24px 16px;
  text-align: center;
}

.dialog-title {
  color: #0d2c6d;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 8px;
}

.dialog-subtitle {
  color: #64748b;
  font-size: 16px;
}

.form-fields {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-field {
  width: 100%;
}

.field-input {
  width: 100%;
}

.checkbox-field {
  margin-top: 8px;
}

.checkbox-label {
  font-size: 16px;
  font-weight: 500;
  color: #0f172a;
}

.progress-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px 0;
  gap: 8px;
}

.progress-text {
  font-size: 14px;
  color: #64748b;
}

.dialog-actions {
  padding: 16px 24px 24px;
  display: flex;
  justify-content: center;
  gap: 16px;
}

.cancel-btn,
.action-btn {
  min-width: 140px;
  text-transform: none;
  font-weight: 500;
  letter-spacing: 0;
  border-radius: 8px;
}

@media (max-width: 600px) {
  .dialog-actions {
    flex-direction: column-reverse;
  }

  .cancel-btn,
  .action-btn {
    width: 100%;
  }
}
</style>